import type * as Types from './types';

export default (({ className }) => (
  <p className={className}>Loading...</p>
)) as Types.Default;
